import { render, staticRenderFns } from "./aftermarketInfo.vue?vue&type=template&id=a08fc97e"
import script from "./aftermarketInfo.vue?vue&type=script&lang=js"
export * from "./aftermarketInfo.vue?vue&type=script&lang=js"
import style0 from "./aftermarketInfo.vue?vue&type=style&index=0&id=a08fc97e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports